function hasIds(value) {
    if (value == null) return false;
    if (Array.isArray(value)) return value.length > 0;
    return String(value).trim().length > 0;
}

export function isGlobalOpportunity(opportunity) {
    if (!opportunity) return false;

    return (
        hasIds(opportunity.businessIds ?? opportunity.business_ids) ||
        hasIds(opportunity.userIds ?? opportunity.user_ids) ||
        hasIds(opportunity.business_id) ||
        hasIds(opportunity.user_id)
    );
}

export function isIndustryOpportunity(opportunity) {
    return !isGlobalOpportunity(opportunity);
}

export const HIGHLY_RELEVANT_THRESHOLD = 85;

export function getOpportunityRelevanceScore(opportunity) {
    const score = opportunity?.relevanceScore ?? opportunity?.relevance_score;
    if (score == null || score === "") return null;
    const numeric = Number(score);
    return Number.isFinite(numeric) ? numeric : null;
}

export function isHighlyRelevantOpportunity(opportunity) {
    const score = getOpportunityRelevanceScore(opportunity);
    return score != null && score >= HIGHLY_RELEVANT_THRESHOLD;
}

export function normalizeOpportunity(opportunity) {
    if (!opportunity) return opportunity;

    const businessIds = opportunity.business_ids ?? opportunity.businessIds ?? [];
    const userIds = opportunity.user_ids ?? opportunity.userIds ?? [];

    return {
        ...opportunity,
        businessIds,
        userIds,
        engagementAngles: opportunity.engagement_angles ?? opportunity.engagementAngles ?? [],
        contentAngles: opportunity.content_angles ?? opportunity.contentAngles ?? [],
        relevanceScore: opportunity.relevance_score ?? opportunity.relevanceScore ?? null,
        eventName: opportunity.event_name ?? opportunity.eventName ?? "",
        sourceType: opportunity.source_type ?? opportunity.sourceType ?? "",
        expiresAt: opportunity.expires_at ?? opportunity.expiresAt ?? null,
        createdAt: opportunity.created_at ?? opportunity.createdAt ?? null,
        searchKeywords: opportunity.search_keywords ?? opportunity.searchKeywords ?? [],
        isGlobal: isGlobalOpportunity({ ...opportunity, businessIds, userIds }),
    };
}

export function normalizeOpportunitiesResponse(data) {
    let items = [];
    let hasCursorPagination = false;
    let hasMore = false;
    let lastDocId = null;

    if (Array.isArray(data)) {
        items = data;
    } else if (Array.isArray(data?.data)) {
        items = data.data;
        hasCursorPagination = data.has_more != null || data.last_doc_id != null;
        hasMore = Boolean(data.has_more);
        lastDocId = data.last_doc_id ?? null;
    }

    return {
        items: items.map(normalizeOpportunity),
        hasCursorPagination,
        hasMore,
        lastDocId,
    };
}

export function getOpportunityDate(opportunity) {
    return opportunity?.createdAt ?? opportunity?.created_at ?? null;
}
